import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './api/interface';
import { getDealer } from './api';

const dealersSlice = createSlice({
  name: 'dealers',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getDealer.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(getDealer.fulfilled, (state, action) => {
      state.dealer = action.payload;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(getDealer.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
  },
});
export const { setLimit, setSkip, setCurrentPage, setStatus, reset } =
  dealersSlice.actions;
export default dealersSlice.reducer;
